// Icon catalog for Digital calendar & product-type settings.
// Keys are stable string identifiers stored in the DB (`product_type.calendar_icon`).
// Add new icons here — nothing else needs to change to make them selectable.
import {
  Globe,
  Mail,
  MessageCircle,
  Megaphone,
  Image as ImageIcon,
  Monitor,
  Newspaper,
  Video,
  Calendar as CalendarIcon,
  Bell,
  Link as LinkIcon,
  FileText,
  Users,
  BarChart2,
  Star,
  ShoppingBag,
  Phone,
  MapPin,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
  Send,
  Sparkles,
  Share2,
  TrendingUp,
  Gift,
  Tag,
} from 'lucide-react';

// Ordered so common choices appear first in the picker grid.
export const CALENDAR_ICONS = [
  { key: 'globe', label: 'Website', Icon: Globe },
  { key: 'monitor', label: 'Display / Website ad', Icon: Monitor },
  { key: 'image', label: 'Image / Banner', Icon: ImageIcon },
  { key: 'mail', label: 'Email blast', Icon: Mail },
  { key: 'send', label: 'Newsletter', Icon: Send },
  { key: 'facebook', label: 'Facebook', Icon: Facebook },
  { key: 'instagram', label: 'Instagram', Icon: Instagram },
  { key: 'twitter', label: 'Twitter / X', Icon: Twitter },
  { key: 'youtube', label: 'YouTube', Icon: Youtube },
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin },
  { key: 'share', label: 'Social post', Icon: Share2 },
  { key: 'message', label: 'Message / Comment', Icon: MessageCircle },
  { key: 'megaphone', label: 'Promotion', Icon: Megaphone },
  { key: 'newspaper', label: 'Editorial / Print', Icon: Newspaper },
  { key: 'file-text', label: 'Sponsored article', Icon: FileText },
  { key: 'video', label: 'Video ad', Icon: Video },
  { key: 'sparkles', label: 'Advertorial / Featured', Icon: Sparkles },
  { key: 'calendar', label: 'Event / Calendar', Icon: CalendarIcon },
  { key: 'bell', label: 'Notification', Icon: Bell },
  { key: 'link', label: 'Sponsored link', Icon: LinkIcon },
  { key: 'users', label: 'Audience', Icon: Users },
  { key: 'chart', label: 'Campaign / Metrics', Icon: BarChart2 },
  { key: 'trending', label: 'Trending campaign', Icon: TrendingUp },
  { key: 'star', label: 'Featured placement', Icon: Star },
  { key: 'shopping-bag', label: 'Offer / Retail', Icon: ShoppingBag },
  { key: 'tag', label: 'Tag / Deal', Icon: Tag },
  { key: 'gift', label: 'Giveaway', Icon: Gift },
  { key: 'phone', label: 'Call / Contact', Icon: Phone },
  { key: 'map-pin', label: 'Local / Location', Icon: MapPin },
];

// key → { label, Icon }
export const CALENDAR_ICON_MAP = Object.fromEntries(
  CALENDAR_ICONS.map((i) => [i.key, i]),
);

export const DEFAULT_CALENDAR_ICON = Globe;

/**
 * Resolve an icon key to a lucide component. Falls back to Globe when the key
 * is missing or unknown so old bookings still render without crashing.
 */
export function getCalendarIcon(key) {
  if (!key) return DEFAULT_CALENDAR_ICON;
  return CALENDAR_ICON_MAP[key]?.Icon || DEFAULT_CALENDAR_ICON;
}
